import { ReactNode } from "react";
import { Controller, Control, FieldValues, Path } from "react-hook-form";

import { Textarea, TextareaProps } from "src/components/Textarea";

export type { TextareaProps };
export { Textarea };

// ============= RHF Field =============

export interface TextareaFieldProps<TForm extends FieldValues>
  extends Omit<TextareaProps, "value" | "onChange" | "onBlur"> {
  name: Path<TForm>;
  control: Control<TForm, any, any>;
}

export function TextareaField<TForm extends FieldValues>({
  name,
  control,
  ...baseProps
}: TextareaFieldProps<TForm>): ReactNode {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Textarea
          {...baseProps}
          value={field.value ?? ""}
          onChange={field.onChange}
          onBlur={field.onBlur}
          error={fieldState.error?.message}
        />
      )}
    />
  );
}
